module.exports = __webpack_public_path__ + "media/images/thumbs/biology/m_animation_lymphatic_system_functions_10-66492df97279e608c2de3db2962d0ba9.jpg";